// src/header/Header.jsx
import React from 'react';
import { Menu } from './Menu';
import UserMenu from './UserMenu';
import './header.css';

export const Header = () => {
  return (
    <>
      <Menu />
      <UserMenu />
    </>
  );
};
